import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './auth.service';
import { HttpClient } from '@angular/common/http';
import { GlobalService } from './global.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {

  endpoint = this.globalService.endpoint;

  tokenValid: boolean=false;

  constructor(private http: HttpClient, public authService: AuthService, public router: Router, private globalService: GlobalService) {}

  

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (!localStorage.getItem(this.globalService.USER_KEY)) {
      // not logged in so redirect to login page with the return url
      this.router.navigate(['/login'], { queryParams: { returnUrl: state.url }});
      return false;
    }

    const roles = next.data?.['roles'] as string[] | undefined;
    if (roles?.length) {
      const userRole = this.globalService.getUser()?.role;
      if (!roles.includes(userRole)) {
        this.router.navigate(['/opportunities']);
        return false;
      }
    }
    return true;
  }

  
  

}
